import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

const MODE_KEY = 'teknora_theme';
const PALETTE_KEY = 'teknora_palette';

// Swatch preview colors for the picker UI — must stay in sync with the
// matching `[data-palette='...']` blocks in src/styles/tokens.css.
export const PALETTES = [
  { id: 'teknora', label: 'Teknora', swatch: '#005495', swatchAccent: '#43a047' },
  { id: 'midnight', label: 'Midnight', swatch: '#4338ca', swatchAccent: '#06b6d4' },
  { id: 'ocean', label: 'Ocean', swatch: '#0f766e', swatchAccent: '#f59e0b' },
  { id: 'emerald', label: 'Emerald', swatch: '#15803d', swatchAccent: '#b45309' },
];

const readToken = (name) => getComputedStyle(document.documentElement).getPropertyValue(name).trim();

export const ThemeProvider = ({ children }) => {
  const [mode, setModeState] = useState(() => localStorage.getItem(MODE_KEY) || 'light');
  const [palette, setPaletteState] = useState(() => localStorage.getItem(PALETTE_KEY) || 'teknora');
  // 🎯 قيم الألوان الفعلية بعد ما الـ CSS variables اتطبقت — مصدر واحد بيقرأ منه
  // AntdThemeBridge بدل ما يحتفظ بخريطة ألوان منفصلة ممكن تخرج عن التزامن مع tokens.css
  const [resolvedTokens, setResolvedTokens] = useState(null);

  // effect واحدة بتحدّث الـ attributes وتقرأ القيم المحسوبة "بعدها على طول" — لو
  // كانت الاتنين (mode/palette) منفصلين في effects مختلفة ممكن نقرأ قيمة قديمة
  // لسه ما اتحدثتش لو الاتنين اتغيروا في نفس الـ render (زي أول تحميل من localStorage).
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', mode);
    document.documentElement.setAttribute('data-palette', palette);
    localStorage.setItem(MODE_KEY, mode);
    localStorage.setItem(PALETTE_KEY, palette);

    setResolvedTokens({
      colorPrimary: readToken('--color-primary'),
      colorInfo: readToken('--color-primary'),
      colorSuccess: readToken('--status-success'),
      colorWarning: readToken('--status-warning'),
      colorError: readToken('--status-danger'),
      colorBgContainer: readToken('--surface-card'),
      colorBgElevated: readToken('--surface-panel'),
      colorText: readToken('--text-primary'),
      colorBorder: readToken('--border-default'),
    });
  }, [mode, palette]);

  const setMode = (next) => setModeState(next);
  const setPalette = (next) => setPaletteState(next);
  const toggleMode = () => setModeState(prev => (prev === 'light' ? 'dark' : 'light'));

  return (
    <ThemeContext.Provider value={{ mode, palette, setMode, setPalette, toggleMode, resolvedTokens }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
